// extracted by mini-css-extract-plugin
export default {"tableRow":"subzone_tableRow__xNErk","tableCell":"subzone_tableCell__eod+B"};